import { render, staticRenderFns } from "./imprint-text_de.vue?vue&type=template&id=3052ac72"
import script from "./imprint-text_de.vue?vue&type=script&lang=js"
export * from "./imprint-text_de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports